import { ContentService } from "../services/ContentService";

export class Customers {
  contentService = new ContentService();
  customersContainer = document.querySelector(
    '[data-jsSelector="customersContainer"]',
  );

  init(photosDirectory, customers) {
    console.log("Rendering customers", customers);
    if (!customers || !customers.length) {
      return;
    }

    this.customersContainer.innerHTML = "";
    for (const customer of customers) {
      const image = `${photosDirectory}/${customer.logo}`;
      this.customersContainer.insertAdjacentHTML(
        "beforeend",
        `
        <div class="customer-item">
        <div class="overlay">${customer.name}</div>
          <img src="${image}" alt="${customer.name}"/>
        </div>`,
      );
    }
  }
}
